import React, { useEffect, useState } from 'react';
const NAMES = ['Carlos', 'Miguel', 'Andrea', 'Laura', 'Javier', 'Valentina', 'Pablo', 'Sofía', 'Ricardo', 'Camila', 'Diego', 'Lucía', 'Fernando', 'Ana', 'José', 'María', 'Luis', 'Carolina', 'Antonio', 'Patricia', 'Manuel', 'Isabel', 'Francisco', 'Elena', 'Alejandro', 'Gabriela', 'Roberto', 'Daniela', 'Sergio', 'Natalia'];
const CITIES = ['Ciudad de México', 'Bogotá', 'Santiago de Chile', 'Lima', 'Madrid', 'Barcelona', 'Montevideo', 'Caracas', 'Buenos Aires', 'Medellín', 'Guadalajara', 'Valencia', 'Quito', 'La Paz', 'San José', 'Panamá', 'Santo Domingo', 'Asunción', 'Managua', 'Tegucigalpa'];
const PRODUCTS = [{
  name: 'MegaPack + Pádel Pro Business',
  emoji: '🏆'
}, {
  name: 'MegaPack Padel Listo',
  emoji: '🎾'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 25000 + Math.floor(Math.random() * 20000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-320">
      <div className="bg-[#000d1a] border border-[#00B4D8]/40 rounded-xl shadow-2xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-321">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors p-1" aria-label="Cerrar notificación" data-id="element-322">
          ✕
        </button>
        <div className="flex items-center gap-2 mb-2" data-id="element-323">
          <div className="w-2 h-2 bg-[#00B4D8] rounded-full animate-pulse" data-id="element-324" />
          <span className="text-[#00B4D8] text-xs font-bold uppercase tracking-wider" data-id="element-325">
            Compra verificada
          </span>
        </div>
        <p className="text-white text-sm mb-1" data-id="element-326">
          <span className="font-bold" data-id="element-327">
            {notification.name} {notification.initial}.
          </span>{' '}
          de {notification.city}
        </p>
        <p className="text-gray-300 text-sm mb-2" data-id="element-328">
          compró{' '}
          <span className="text-[#00B4D8] font-bold" data-id="element-329">
            {notification.product.name} {notification.product.emoji}
          </span>
        </p>
        <p className="text-gray-500 text-xs" data-id="element-330">
          hace {notification.timeAgo} minutos
        </p>
      </div>
    </div>;
}